// 
let nextId = 0;

export const getNextUniqueId = () => {
  nextId += 1;
  return `id${nextId.toString(36)}`;
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/lib/idGenerator.js